var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NonNegativeIntResolver } from "graphql-scalars";
import { Field, InterfaceType } from "type-graphql";
let AbstractGraphQLPaginatedResponse = class AbstractGraphQLPaginatedResponse {
    total;
    static newPaginated({ data, total, }) {
        const response = new this();
        response.data = data;
        response.total = total;
        return response;
    }
};
__decorate([
    Field(() => NonNegativeIntResolver, {
        description: "The total number of items",
        nullable: false,
    }),
    __metadata("design:type", Number)
], AbstractGraphQLPaginatedResponse.prototype, "total", void 0);
AbstractGraphQLPaginatedResponse = __decorate([
    InterfaceType({
        description: "API response",
    })
], AbstractGraphQLPaginatedResponse);
export { AbstractGraphQLPaginatedResponse };
//# sourceMappingURL=PaginatedResponse.js.map